import React from 'react'
import { IReportComponentBlueprint } from '../../../../services/decoders/blueprintDecoder'

export type CreateNodeParams = {
  parent: IReportComponentBlueprint[]
  nodeTitle: string
  type: string
  parentId?: string
}

export interface ITreeViewContext {
  onItemClick: ({ id, type }: { id: string; type: string }) => void
  onCreateNode: (params: CreateNodeParams) => void
  onEditDrilldown: (nodeId: string) => void
  onDeleteNode: (data: IReportComponentBlueprint | null) => void
  onOpenNodePopover: (nodeId: string, type: string) => void
  onCloseNodePopover: () => void
  showNodePopover: boolean
  selectedNodeId: string
  currentType: string
  readOnly: boolean
  onDelete: (data: IReportComponentBlueprint | null) => void
  lastAddedNodeId?: string
}

export const TreeViewContext = React.createContext({} as ITreeViewContext)
